import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: t = 16, useVw: o, useRem: n, color: c, withColor: l, removeClassName: a, disableSSR: m, style: i, ...p }) => {
  const h = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-tongzhi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), height: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), className: a ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: a ? "" : "24px-éç¥"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: a ? "" : "normal",
        d: "M12.756 2.132a.8.8 0 0 0-1.6 0v1.271c-3.768.359-6.828 3.222-6.828 6.856v7.155H2.925a.8.8 0 0 0 0 1.6H8.67a3.304 3.304 0 0 0 6.581 0h5.824a.8.8 0 0 0 0-1.6h-1.493V10.26c0-3.634-3.06-6.497-6.826-6.856v-1.27Zm-.801 2.833c-3.416 0-6.027 2.455-6.027 5.294v7.155h12.054V10.26c0-2.839-2.61-5.294-6.027-5.294Zm-1.672 14.05a1.704 1.704 0 0 0 3.355 0h-3.355Z",
        fillRule: "evenodd",
        fill: l ? r(c, 0, "#262933") : "#262933",
        datafollowfill: l ? r(c, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = f;
export {
  E as default
};
